import script from "./T.vue?vue&type=script&lang=ts"
export * from "./T.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__